import React, { useState } from 'react'
import './RadioButton.scss'

type InputFieldType = {
  label?: string
  name: string
  options: Array<{ label: string; value: any; }>
  defaultValue?: any
  handleChangeFn: (event: any) => void
  disabled?: boolean
  tooltipText?: string
}

const RadioButton: React.FC<InputFieldType> = ({ label, name, options, defaultValue, handleChangeFn, disabled = false, tooltipText }) => {
  const [value, setValue] = React.useState<any>(() => {
    if (defaultValue !== undefined && defaultValue !== null) {
      return defaultValue
    }
    return null
  })
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <div>
      <div className="d-flex align-items-center gap-2">
        {label}
        {tooltipText && (
          <div className="position-relative">
            <i
              className="bi bi-info-circle text-muted"
              style={{ cursor: 'help' }}
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            ></i>
            {showTooltip && (
              <div
                className="radio-button-tooltip position-absolute bottom-80 start-50 translate-middle-x mb-2 p-2 bg-dark text-white rounded small"
              >
                {tooltipText}
              </div>
            )}
          </div>
        )}
      </div>
      <div className="form-check">
        {options.map((option) => (
          <div key={option.label} className="form-check">
            <input
              type="radio"
              id={option.label}
              name={name}
              value={option.value}
              className="form-check-input"
              checked={String(option.value) === value}
              onChange={(e) => {
                setValue(e.target.value)
                handleChangeFn && handleChangeFn(e)
              }}
              disabled={disabled}
            />
            <label htmlFor={option.label} className="form-check-label">
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}

export default RadioButton
